import type { UserCity } from 'src/entities/profile'
import type { IProfileGateway } from './ports/IProfileGateway'

// Сценарий: получить город пользователя (нужен геоподсказкам адреса).
export class GetCityInfo {
  constructor(private readonly gateway: IProfileGateway) {}

  execute(signal?: AbortSignal): Promise<UserCity> {
    return this.gateway.getCityInfo(signal)
  }
}
